import { Coverages } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.styles";
import styled from "styled-components";

export const SavingAdvicesMessage = styled.div`
  background: ${({ theme }) => theme.surface.color};
  padding: 12px 24px;

  .AdviceDiffInfo {
    margin-left: 32px;
  }
`;

export const DiffMessageContainer = styled(Coverages)`
  align-items: flex-start;
  display: flex;
  height: auto;
`;

export const IconContainer = styled.div`
  margin-right: 16px;
`;

interface DownloadContainerProps {
  withMargin: boolean;
}

export const DownloadContainer = styled.div<DownloadContainerProps>`
  margin-top: ${({ withMargin }) => (withMargin ? "32px" : "0px")};
`;

export const WhiteSurface = styled.div`
  background: #fff;
  padding: 8px 16px;
`;
